<script setup>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useOrganizationStore } from "./stores/organizationStore.js";

const organizationStore = useOrganizationStore();
const pageReady = ref(false);
const route = useRoute();

// Mark the initial lookup as pending before the first route renders so a
// branded subdomain does not briefly mount the marketing home page.
organizationStore.organizationInfoLoading = true;

onMounted(async () => {
  await organizationStore.getOrganizationInfo();
  pageReady.value = true;
});
</script>

<template>
  <div class="flex-grow min-h-screen flex flex-col">
    <router-view />
  </div>
</template>

<style>
[v-cloak] {
  display: none;
}
</style>
